export const CONTACT_COLUMNS = [
  { id: 'select', label: '', alwaysVisible: true, defaultVisible: true },
  { id: 'contact', label: 'Contact', alwaysVisible: true, defaultVisible: true },
  { id: 'type', label: 'Contact Type', alwaysVisible: false, defaultVisible: true },
  { id: 'title', label: 'Title', alwaysVisible: false, defaultVisible: false },
  { id: 'company', label: 'Company', alwaysVisible: false, defaultVisible: false },
  { id: 'email', label: 'Email', alwaysVisible: false, defaultVisible: false },
  { id: 'phone', label: 'Phone', alwaysVisible: false, defaultVisible: false },
  { id: 'address1', label: 'Address', alwaysVisible: false, defaultVisible: false },
  { id: 'address2', label: 'Address 2', alwaysVisible: false, defaultVisible: false },
  { id: 'city', label: 'City', alwaysVisible: false, defaultVisible: false },
  { id: 'state', label: 'State', alwaysVisible: false, defaultVisible: false },
  { id: 'zip', label: 'Zip', alwaysVisible: false, defaultVisible: false },
  { id: 'created_at', label: 'Date Added', alwaysVisible: false, defaultVisible: false },
  { id: 'events', label: 'Total Events', alwaysVisible: false, defaultVisible: true },
];

export const SORT_OPTIONS = [
  { value: 'first_name asc', label: 'Name (A-Z)' },
  { value: 'first_name desc', label: 'Name (Z-A)' },
  { value: 'created_at desc', label: 'Newest First' },
  { value: 'created_at asc', label: 'Oldest First' },
  { value: 'email asc', label: 'Email (A-Z)' },
  { value: 'city asc', label: 'City (A-Z)' },
  { value: 'state asc', label: 'State (A-Z)' },
  { value: 'calendar_events_count desc', label: 'Total Events (High-Low)' },
];

export const getDefaultVisibleColumns = () =>
  CONTACT_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  CONTACT_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
